import { config } from '@brands/config/config';
import { setUser } from '@brands/store/slices/authSlice';
import { clearCareAdvisorMyProfile } from '@brands/store/slices/careAdvisorMyProfile';
import { clearPatientState } from '@brands/store/slices/currentPatientState';
import { resetDependents } from '@brands/store/slices/dependentsSlice';
import { setIsFromHandoff } from '@brands/store/slices/isFromHandOffSlice';
import { setOrganizationPrices } from '@brands/store/slices/organizationPricingSlice';
import { setOrganization } from '@brands/store/slices/organizationSlice';
import { clearPageState, setDependentId, setIsFromSelectPatient } from '@brands/store/slices/pageStateSlice';
import { resetForm, resetIsFromSmileScanReport, resetSelectedPatient } from '@brands/store/slices/patientFormSlice';
import { clearPatientMyProfile } from '@brands/store/slices/patientMyProfileSlice';
import { clearProviderMyProfile } from '@brands/store/slices/providerMyProfileSlice';
import { setShowVideoThumbnail } from '@brands/store/slices/showVideoThumbnailSlice';
import { cookieOptions } from '@brands/Utils/getToken';
import Cookies from 'js-cookie';
import { AnyAction, Dispatch } from 'redux';

export const signOut = (dispatch: Dispatch<AnyAction>): void => {
  // Remove auth cookies with every possible option combination
  const cookieNames = ['jwtToken', 'refreshToken', 'jwtTokenExpire', 'userInfo'];
  const opts = cookieOptions();
  cookieNames.forEach((name) => {
    Cookies.remove(name, opts);
    Cookies.remove(name);
    Cookies.remove(name, { path: '/' });
    Cookies.remove(name, { path: '/', domain: opts.domain });
  });

  // Brute-force clear all cookies via document.cookie
  document.cookie.split(';').forEach((c) => {
    const name = c.split('=')[0].trim();
    document.cookie = `${name}=;expires=${new Date(0).toUTCString()};path=/`;
    if (opts.domain) {
      document.cookie = `${name}=;expires=${new Date(0).toUTCString()};path=/;domain=${opts.domain}`;
    }
  });

  dispatch(setUser({ userInfo: null }));
  dispatch(setOrganization({ currentOrganization: null }));
  dispatch(setOrganizationPrices({ currentOrganizationPrices: null }));
  dispatch(resetForm());
  dispatch(resetSelectedPatient());
  dispatch(resetIsFromSmileScanReport());
  dispatch(clearProviderMyProfile());
  dispatch(clearPatientMyProfile());
  dispatch(clearCareAdvisorMyProfile());
  dispatch(resetDependents());
  dispatch(setIsFromSelectPatient(false));
  dispatch(setDependentId(null));
  dispatch(clearPageState());
  dispatch(setIsFromHandoff(false));
  dispatch(setShowVideoThumbnail(false));
  dispatch(clearPatientState());

  // Clear all storage AFTER dispatches so redux-persist can't
  // write stale state back before the page navigates
  window.localStorage.clear();
  window.sessionStorage.clear();
};
